import { GridRenderCellParams, GridRowId } from '@mui/x-data-grid-pro';
import { CommodityPriceFieldWithController } from '@procureai/ui-form-mui';
import { useFormContext } from 'react-hook-form';

import { CommodityUndercoverages } from '../../CoverageAssistantWidget.schema';
import { CoveragePredictionRow } from '../../CoverageAssistantWidget.types';

interface PriceSourceCellProps extends GridRenderCellParams<CoveragePredictionRow> {
  getRowIndex: (id: GridRowId) => number;
}

export const PriceSourceCell = ({ row, getRowIndex }: PriceSourceCellProps) => {
  const { control } = useFormContext<CommodityUndercoverages>();

  const rowIndex = getRowIndex(row.rowId);

  return (
    <CommodityPriceFieldWithController
      control={control}
      required
      sx={{
        '& .MuiFormHelperText-root': {
          display: 'none',
        },
      }}
      name={`predictions.${rowIndex}.baselinePricePerPriceUnit`}
      currency={row.currency}
      commodityId={row.commodityId}
      organizationId={row.organizationId}
    />
  );
};
